<div class="card p-3 mt-2">
    <nz-skeleton [nzLoading]="loading" [nzActive]="true" class="d-flex flex-column">
        <div class="d-flex flex-column gap-2">
            <div class="title">QRIS Management</div>
            <span class="text-secondary text-wrap">Easily manage and organize your QRIS in one place.</span>
        </div>
        <hr>
        <div class="flex flex-col gap-12 p-4">
          <app-upload-qris class="w-full" (afterUpload)="handleAfterUpload()"></app-upload-qris>
          <app-qris-list-table class="w-full"></app-qris-list-table>
        </div>
    </nz-skeleton>
</div>
